import { render, staticRenderFns } from "./GonggaoBianji.vue?vue&type=template&id=a3501e4c&"
import script from "./GonggaoBianji.vue?vue&type=script&lang=js&"
export * from "./GonggaoBianji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GonggaoBianji.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=Yangshi.css"
if (typeof block0 === 'function') block0(component)

export default component.exports